import { FC, useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { stylesContact } from "./stylesContact";
import { useSendContactUsMessageMutation } from "@/store/api/contactUsApi";
import CustomToast from "@/components/UI/CustomToast/CustomToast";
import CustomLoader from "@/components/UI/CustomLoader/CustomLoader";

const ContactUs: FC = () => {
  const [message, setMessage] = useState("");
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [toastSuccess, setToastSuccess] = useState<boolean | undefined>(undefined);

  const [sendMessage, { isLoading }] = useSendContactUsMessageMutation();

  const handleSubmit = async () => {
    if (!message.trim()) return;

    try {
      const response = await sendMessage({ message }).unwrap();
      setMessage("");

      setToastMessage(response.message);
      setToastSuccess(true);
    } catch (error) {
      setToastMessage("Something went wrong. Please try again later.");
      setToastSuccess(false);
    }
  };

  return (
    <>
      <Box sx={stylesContact.pageBackground}>
        <Box sx={stylesContact.wrapper}>
          <Typography sx={stylesContact.fieldLabel}>Message</Typography>
          <TextField
            placeholder="Enter your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            multiline
            rows={6}
            sx={stylesContact.inputField}
            className="custom-scrollbar"
          />

          <Button
            onClick={handleSubmit}
            sx={stylesContact.submitButton}
            disabled={isLoading || !message.trim()}
          >
            {isLoading ? "Sending..." : "Send Message"}
            <CustomLoader loading={isLoading} size={20} color="#FFFFFF" />
          </Button>
        </Box>
      </Box>

      {toastMessage && (
        <CustomToast
          message={toastMessage}
          success={toastSuccess}
          onClose={() => setToastMessage(null)}
        />
      )}
    </>
  );
};

export default ContactUs;
